import { generateMeasuresFromDimensions } from './generate-measures.js';
import { departmentLink, legislativeItemLink, meetingBodyLink, userLink } from './links.js';
import { legislativeItemSystemStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'department_legislative_activity.days_in_pipeline': {
        aggregations: ['avg', 'max'],
        label: 'Days In Pipeline',
        type: 'number',
    },
};
/**
 * Combination data source: Agenda Items x Departments.
 * Volume and pipeline metrics by originating department: which departments submit the most
 * items, average processing time, and items stuck in workflow.
 */
export const departmentLegislativeActivityCube = {
    category: 'Legislation',
    description: 'Legislative items by originating department with volume metrics and pipeline duration.',
    label: 'Legislative Activity by Department',
    requiredModule: 'hasAgenda',
    measures: {
        'department_legislative_activity.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'department_legislative_activity.distinct_departments': {
            label: 'Distinct Departments',
            type: 'number',
        },
    },
    dimensions: {
        ...aggregatableDimensions,
        // Department
        'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
        // Legislative Item
        'legislative_items.code': { label: 'Item Number', link: legislativeItemLink, type: 'string' },
        'legislative_items.full_title': {
            label: 'Item Title',
            link: legislativeItemLink,
            type: 'string',
        },
        'legislative_items.requesting_consent': { label: 'Consent Agenda', type: 'boolean' },
        'legislative_items.requesting_emergency': { label: 'Emergency Request', type: 'boolean' },
        'legislative_items.short_title': { label: 'Short Title', type: 'string' },
        'legislative_items.status': {
            label: 'System Status',
            type: 'string',
            valueLabels: legislativeItemSystemStatusValueLabels,
        },
        // Status & Type
        'legislative_statuses.name': { label: 'Public Meeting Status', type: 'string' },
        'legislative_types.name': { label: 'Item Type', type: 'string' },
        // Meeting Body
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        // Staff Contact
        'users.display_name': { label: 'Staff Contact', link: userLink, type: 'string' },
    },
    timeDimensions: {
        'legislative_items.created_at': { label: 'Item Created At', type: 'date' },
        'legislative_items.target_meeting_date': { label: 'Target Meeting Date', type: 'date' },
    },
};
